/**
 * Уведомление о новых счетах в личном кабинете TAS.PRO.
 */

const billSelector =
    'a.lk__orders-list-item-account[href*="tas_bill_file="]';

const headerBadgeClass = 'tas-bill-header-notice';

function readParams(link) {
    try {
        const url = new URL(
            link.href,
            window.location.origin
        );

        return {
            orderId:
                parseInt(
                    url.searchParams.get('tas_bill_order'),
                    10
                ) || 0,
            fileId:
                parseInt(
                    url.searchParams.get('tas_bill_file'),
                    10
                ) || 0,
            isNew:
                url.searchParams.get('tas_bill_new') === '1'
        };
    } catch (error) {
        return {
            orderId: 0,
            fileId: 0,
            isNew: false
        };
    }
}

function findProfileControl() {
    const candidates = document.querySelectorAll(
        'a, button, [role="button"]'
    );

    for (let i = 0; i < candidates.length; i++) {
        const text = (candidates[i].textContent || '')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();

        if (text === 'мой профиль') {
            return candidates[i];
        }
    }

    return null;
}

function getNewBillKeys() {
    const keys = {};
    const links = document.querySelectorAll(
        billSelector
    );

    Array.prototype.forEach.call(
        links,
        function (link) {
            const params = readParams(link);

            if (
                params.isNew
                && params.orderId
                && params.fileId
            ) {
                keys[
                    params.orderId
                    + ':'
                    + params.fileId
                ] = true;
            }
        }
    );

    return Object.keys(keys);
}

function renderHeaderNotice() {
    const control = findProfileControl();

    if (!control) {
        return;
    }

    const keys = getNewBillKeys();

    let badge = control.querySelector(
        '.' + headerBadgeClass
    );

    control.classList.add(
        'tas-bill-profile-control'
    );

    if (!keys.length) {
        if (badge) {
            badge.remove();
        }

        control.removeAttribute(
            'data-tas-new-bills'
        );

        return;
    }

    if (!badge) {
        badge = document.createElement('span');
        badge.className = headerBadgeClass;
        control.appendChild(badge);
    }

    badge.textContent = String(keys.length);

    badge.setAttribute(
        'aria-label',
        keys.length === 1
            ? '1 новый счёт'
            : keys.length + ' новых счёта'
    );

    control.setAttribute(
        'data-tas-new-bills',
        String(keys.length)
    );
}

function markLinkLocallyRead(link) {
    try {
        const url = new URL(
            link.href,
            window.location.origin
        );

        url.searchParams.set(
            'tas_bill_new',
            '0'
        );

        link.href = url.toString();
    } catch (error) {
        link.dataset.tasBillLocallyRead = '1';
    }

    const oldBadge = link.querySelector(
        '.tas-bill-new'
    );

    if (oldBadge) {
        oldBadge.remove();
    }
}

function markRead(link) {
    const params = readParams(link);

    if (
        !params.orderId
        || !params.fileId
        || !params.isNew
    ) {
        return;
    }

    markLinkLocallyRead(link);
    renderHeaderNotice();

    if (
        window.BX
        && BX.ajax
        && typeof BX.ajax.runComponentAction
            === 'function'
    ) {
        BX.ajax.runComponentAction(
            'sintex:cabinet',
            'markBillRead',
            {
                mode: 'class',
                data: {
                    orderId: params.orderId,
                    fileId: params.fileId
                }
            }
        );
    }
}

function init(root) {
    const scope =
        root && root.querySelectorAll
            ? root
            : document;

    const links = scope.querySelectorAll(
        billSelector
    );

    Array.prototype.forEach.call(
        links,
        function (link) {
            const oldBadge = link.querySelector(
                '.tas-bill-new'
            );

            if (oldBadge) {
                oldBadge.remove();
            }

            if (
                link.dataset.tasBillNoticeReady
                    === '2'
            ) {
                return;
            }

            link.dataset.tasBillNoticeReady = '2';

            link.addEventListener(
                'click',
                function () {
                    markRead(link);
                }
            );
        }
    );

    renderHeaderNotice();
}

export function initLkBillNotice() {
    init(document);

    const observer = new MutationObserver(
        function (mutations) {
            let needsInit = false;

            mutations.forEach(
                function (mutation) {
                    if (mutation.addedNodes.length) {
                        needsInit = true;
                    }
                }
            );

            if (needsInit) {
                init(document);
            }
        }
    );

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}
